import { createTheme } from '@mui/material/styles'
import constants from '../../constants'

const publicTheme = createTheme({
  palette: {
    primary: {
      main: constants.colors.neutrals.black,
      contrastText: constants.colors.neutrals.white,
    },
    secondary: {
      main: constants.colors.neutrals.white,
      contrastText: constants.colors.neutrals.black,
    },
  },
  shape: { borderRadius: 8 },
  components: {
    MuiButton: {
      styleOverrides: {
        root: { textTransform: 'none' },
      },
    },
  },
})

export default publicTheme
